import { render, staticRenderFns } from "./ExceptionPage.vue?vue&type=template&id=935d3caa&scoped=true&"
import script from "./ExceptionPage.vue?vue&type=script&lang=ts&"
export * from "./ExceptionPage.vue?vue&type=script&lang=ts&"
import style0 from "./ExceptionPage.vue?vue&type=style&index=0&id=935d3caa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935d3caa",
  null
  
)

export default component.exports